import type { PaymentMethod } from "../src/api/payment-methods";

export function isPayoutMethod(
  method: PaymentMethod,
): method is PaymentMethod & {
  type: "bank" | "mobile_money";
} {
  return method.type === "bank" || method.type === "mobile_money";
}

export function getPayoutMethodLabel(method: PaymentMethod) {
  if (method.type === "bank") {
    return (
      method.bank ||
      (method as Record<string, string | undefined>).bankName ||
      method.accountName ||
      "Bank account"
    );
  }
  return (
    method.provider ||
    method.accountName ||
    (method as Record<string, string | undefined>).accountHolderName ||
    "Mobile money account"
  );
}
